import {memo} from 'react';
import {HospitalData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: HospitalData;
}

export const HospitalMarker = memo(
  ({map, position, item}: IProps) => {
    return (
      <NearbyInfoMarker
        typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.HOSPITAL]}
        config={{
          map,
          position,
        }}
        item={{
          name: item.name,
          count: item.bedsCount,
        }}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
